import {Component} from 'vue-facing-decorator';
import {FormItem} from '@/app/views/components/form/FormItem';
import {Store} from "@/app/stores/Store";

@Component({})
export default class FormPlatformSwitch extends FormItem<boolean> {

    declare public $refs: {
        checkbox: HTMLInputElement;
    };

    public get color(): string {
        if (Store.app.platformIsCircularity) {
            return 'bg-green-400';
        }
        if (Store.app.platformIsManufy) {
            return 'bg-blue-400';
        }

        return 'bg-neutral-20';
    }

    public get isDisabled(): boolean {
        return Store.app.platformIsUndefined;
    }

    public get modelValues(): boolean {
        return !Store.app.platformIsCircularity;
    }

    public handleInput(evt: Event): void {
        this.updateValue((evt.target as HTMLInputElement).checked);
    }

}
